/*! JointJS+ v4.1.0 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-12-04


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/

// @ts-nocheck
import * as joint from '@joint/plus';
import { textAttrs, textMarkup } from '../config/markups';

const cache = new Map();
export namespace app {

    export class Link extends joint.shapes.standard.Link {

        defaultLabel = {
            attrs: {
                rect: {
                    fill: '#ffffff',
                    stroke: '#353535',
                    strokeWidth: 1,
                    width: 'calc(w + 10)',
                    height: 'calc(h + 10)',
                    x: 'calc(x - 5)',
                    y: 'calc(y - 5)'
                }
            }
        };

        private getDataWidthCached = function(d: string){
            if (cache.has(d)) {
                return cache.get(d);
            } else {
                const bbox = (new joint.g.Path(d)).bbox();
                cache.set(d, bbox ? bbox.width : 0);
                return cache.get(d);
            }
        };

        static connectionPoint(line: any, view: any, magnet: any, _opt: any, type: any, linkView: any): joint.g.Point {
            const link = linkView.model;
            const markerWidth = (link.get('type') === 'app.Link') ? link.getMarkerWidth(type) : 0;
            const opt: any = { offset: markerWidth, stroke: true };
            // connection point for UML shapes lies on the root group containing all the shapes components
            const modelType = view.model.get('type');
            // taking the border stroke-width into account
            if (modelType === 'standard.InscribedImage') { opt.selector = 'border'; }
            return joint.connectionPoints.boundary.call(this, line, view, magnet, opt, type, linkView);
        }

        defaults() {
            return joint.util.defaultsDeep({
                type: 'app.Link',
                router: {
                    name: 'normal'
                },
                connector: {
                    name: 'rounded'
                },
                labels: [],
                attrs: {
                    line: {
                        stroke:'#3771B8',
                        strokeDasharray: '0',
                        strokeWidth: 2,
                        fill: 'none',
                        sourceMarker: {
                            type: 'path',
                            d: 'M 0 0 0 0',
                            stroke: 'none'
                        },
                        'targetMarker': {
                            'd':'M 0 0 0 0'
                        }
                    }
                }
            }, joint.shapes.standard.Link.prototype.defaults);
        }

        getMarkerWidth(type: any) {
            const d = (type === 'source') ? this.attr('line/sourceMarker/d') : this.attr('line/targetMarker/d');
            return this.getDataWidth(d);
        }

        getDataWidth(d: any) {
            return this.getDataWidthCached(d);
        }
    }
    export class Line extends joint.dia.Element {
      defaults() {
        return joint.util.defaultsDeep({
            type: 'app.Line',
            size: { width: 60, height: 40 },
            markup: [
              { tagName: 'rect', selector: 'body' },
              { tagName: 'line', selector: 'line' }
            ],
            attrs: {
              body: {
                x: 0, y: 0,
                width: 'calc(w)', height: 'calc(h)',
                fill: 'transparent',
                stroke: 'transparent',
              },
              line: {
                x1: 0, y1: 'calc(h - 5)',
                x2: 'calc(w)', y2: 5,
                stroke: '#2c3e50',
                strokeWidth: 2
              }
            },
            targetAttributes: {
              size: { width: 150, height: 20 },
              attrs: {
                line: {
                  x1: 10, y1: 'calc(h/2)',
                  x2: 'calc(w - 10)', y2: 'calc(h/2)',
                }
              }
            }
          }, super.defaults)
        }
    }

    export class Rectangle extends joint.dia.Element {
      defaults() {
        return joint.util.defaultsDeep({
            type: 'app.Rectangle',
            markup: textMarkup(),
            attrs: {
              body: {
                x: 0,
                y: 0,
                width: 'calc(w)',
                height: 'calc(h)',
                rx: 2,
                ry: 2,
                strokeWidth: 2,
                strokeDasharray: '0'
              },
              ...textAttrs({padding: '0 10px'})
            }
          }, super.defaults)
        }
    }

}

// re-export build-in shapes from rappid
export const standard = joint.shapes.standard;
